<template>
  <div id="app">
    <Navheader id="header"></Navheader>
    <!-- <nav>
      <router-link to="/">Home</router-link> |
      <router-link to="/about">About</router-link>
    </nav> -->
    <router-view id="router_viewbody" />
    <Footer></Footer>
    <!-- <Navbar></Navbar> -->
  </div>
</template>
<script>
import Navheader from '@/components/nav/index.vue'
import Navbar from '@/components/navbar/index.vue'
import Footer from '@/components/footer/index.vue'
import { mapState } from 'vuex';
import GA4EventApi from '@/js/GA4EventApi';
export default {
  components: {
    Navbar,
    Navheader,
    Footer
  },
  data() {
    return {
      webmeta: {
        meta_description: '',
        meta_keywords: '',
        og_description: '',
        og_image: '',
        og_title: '',
        og_url: '',
        icon: ''
      }
    }
  },

  async serverPrefetch() {
    const url = this.$ssrContext.clientUrl;
    // const url = 'https://aibo.lytc9988.uk';
    // console.log(url);
    const response = await this.$store.dispatch('header/getnav', url);
    this.webmeta = response;
    // console.log(this.webmeta);
  },
  metaInfo() {
    // console.log(123);
    // console.log(this);
    return {
      title: this.webmeta.og_title,
      link: [
        {
          rel: "icon",
          type: "image/x-icon",
          href: this.webmeta.icon,
        },
      ],
      meta: [
        { vmid: 'description', name: 'description', content: this.webmeta.meta_description },
        { vmid: 'keywords', name: 'keywords', content: this.webmeta.meta_keywords },
        { vmid: 'url', property: 'og:url', content: this.webmeta.og_url },
        { vmid: 'title', property: 'og:title', content: this.webmeta.og_title },
        { vmid: 'og_description', property: 'og:description', content: this.webmeta.og_description },
        { vmid: 'image', property: 'og:image', content: this.webmeta.og_image },
      ]
    }
  },
  computed: {
    ...mapState('header', ['website', 'getads', 'getmc', 'getfb', 'ga_state', 'getga_id', 'getgtm_id']),
  },
  mounted() {
    this.$store.dispatch('header/getnav').then(e => {
      // console.log(this.$store.getters["header/ga_state"]);
      if (this.$store.getters["header/ga_state"]) {
        let script1 = document.createElement('script');
        script1.async = true;
        script1.src = `https://www.googletagmanager.com/gtag/js?id=${this.getga_id}`;
        document.head.appendChild(script1);

        // let script2 = document.createElement('script');
        // script2.innerHTML = `
        //         window.dataLayer = window.dataLayer || [];
        //         function gtag() { dataLayer.push(arguments); }
        //         gtag('js', new Date());
        //         gtag('config', '${this.getga_id}');
        //         gtag('config', '${this.getads?.id}');
        //         gtag('event', 'conversion', {'send_to': '${this.getads?.browse}'});
        //     `;
        // document.head.appendChild(script2);
        // Microsoft Clarity
        let script3 = document.createElement('script');
        script3.type = 'text/javascript';
        script3.innerHTML = this.getmc;
        document.head.appendChild(script3);
        this.$store.commit('header/SET_GA_STATE', false);
        const GAFourEventApi = new GA4EventApi(this.getgtm_id);
        GAFourEventApi.injectGtm();
      }
      // console.log(e);
      this.webmeta = e;
    });




    function updateNavHeaderHeight() {
      var navHeaderHeight = document.getElementById('header').offsetHeight;
      // var FooterHeight = document.getElementById('footer').offsetHeight;
      document.getElementById('router_viewbody').style.paddingTop = navHeaderHeight + 'px';
      // document.getElementById('router_viewbody').style.height  = `calc(100vh - ${navHeaderHeight+FooterHeight}px)`;
      return navHeaderHeight;
    }

    updateNavHeaderHeight();

    // console.log(this.$route)
    window.addEventListener('load', function () {
      // 获取navheader的高度
      var navHeaderHeight = document.getElementById('header').offsetHeight;

      // // 设置body的padding-top为navheader的高度
      document.getElementById('router_viewbody').style.paddingTop = navHeaderHeight + 'px';


      // // 监听滚动事件
      var navHeader = document.getElementById('header');
      var lastScrollTop = 0;
      window.addEventListener('scroll', function () {
        var navHeaderHeight = updateNavHeaderHeight();
        var scrollTop = window.pageYOffset || document.documentElement.scrollTop;
        if (scrollTop > lastScrollTop) {
          // 向下滚动
          if (scrollTop > navHeaderHeight) {
            navHeader.style.top = -navHeaderHeight + 'px';
          }
        } else {
          // 向上滚动
          navHeader.style.top = '0';
        }
        lastScrollTop = scrollTop;
      });


    });

    window.addEventListener('resize', function () {
      // 当窗口大小改变时，重新计算navHeaderHeight
      updateNavHeaderHeight();
    });

  }
}
</script>
<style src="./assets/css/cl_css.scss" lang="scss"></style>
<style lang="scss">
#app {
  // font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, "Noto Sans", sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji";
  font-family: "Noto Sans TC", "Noto Sans JP", sans-serif;
  //   font-family: Avenir, Helvetica, Arial, sans-serif;
  //   -webkit-font-smoothing: antialiased;
  //   -moz-osx-font-smoothing: grayscale;
  //   text-align: center;
  //   color: #2c3e50;
  // height: 1500px;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  height: 100vh;
}

.custom-swal {
  box-sizing: content-box;
  padding: 15px 20px 30px;
  width: 210px;
  height: 80px;
  // width: 100%;
  // height: 100vh;
  /* 或你想要的任何高度 */
}

.icon-popup {
  box-sizing: content-box;
  padding: 15px 20px 15px;
  width: 210px;

  div {
    font-size: 13px;
    letter-spacing: 1px;
  }
}

#router_viewbody {
  // position: relative;
  padding-top: 120px;
  flex: 1;
  padding-bottom: 20px;
}

#navbar {}

/* 隐藏全局滚动条，但仍然允许滚动 */
body {
  // -ms-overflow-style: none;  /* IE 和 Edge */
  // scrollbar-width: none;  /* Firefox */
  word-break: break-word;
}

* {
  font-family: "Noto Sans TC", "Noto Sans JP", sans-serif;
  word-break: break-word;
}

/* 针对 Webkit 浏览器如 Chrome 和 Safari */
body::-webkit-scrollbar {
  // display: none;
}

.video-wrapper {
  position: relative;
  padding-bottom: 56.25%;
  /* 16:9 */
  height: 0;
}

.video-wrapper iframe {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}

</style>
